import { z } from "zod/v4";
import { exclusionDateSchema } from "../../schemas/training";
import { fetchApi, fetchVoid } from "../internal";

export const exclusionDates = {
	create: (clubId: string, seasonId: string, data: unknown) =>
		fetchApi(`/clubs/${clubId}/training/seasons/${seasonId}/dates`, z.array(exclusionDateSchema), {
			body: JSON.stringify(data),
			method: "POST",
		}),
	delete: (clubId: string, seasonId: string, dateId: string) =>
		fetchVoid(`/clubs/${clubId}/training/seasons/${seasonId}/exclusion-dates/${dateId}`, {
			method: "DELETE",
		}),
	list: (clubId: string, seasonId: string) =>
		fetchApi(`/clubs/${clubId}/training/seasons/${seasonId}/dates`, z.array(exclusionDateSchema)),
};
